import EmployeeList from "./EmployeeList";

const EmployeeBiometricList = ({title, description}) => {
  return <EmployeeList title={title} description={description} />;
};

export default EmployeeBiometricList;
